import { defineStore } from 'pinia';
import { StoreModuleName } from '../../constants';
import { UserInfo } from './types';
import { fetchUserInfo } from '~/src/api/modules/user';
import { CustomFetchContext } from '~/src/api/requests/types';
import { ApiResponse } from '~/src/api/types';
import { GLOBAL_CONFIG } from '@/configs/environment/environment';
export const useUserStore = defineStore(StoreModuleName.USER, () => {
  const userInfo = ref<UserInfo>();
  const isLogin = ref(false);
  const loginUrl = ref(`${GLOBAL_CONFIG.envConfig.origin}/user/login.html`);

  const updateUserInfo = async (fetchContext: CustomFetchContext) => {
    const res = await fetchUserInfo({}, {}, fetchContext).catch(() => {
      return {
        data: {},
      } as ApiResponse<UserInfo>;
    });

    userInfo.value = res.data || {};

    if (userInfo.value.id) {
      isLogin.value = true;
    }

    return userInfo.value;
  };

  const getUserInfo = async (fetchContext?: CustomFetchContext) => {
    if (userInfo.value) {
      return userInfo.value;
    }

    if (!fetchContext) {
      return {} as UserInfo;
    }

    return updateUserInfo(fetchContext);
  };

  return {
    isLogin,
    loginUrl,
    userInfo,
    getUserInfo,
    updateUserInfo,
  };
});
